<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

      <div class="text-xs-center">
        <h2 class="headline">大会ルール</h2>

      </div>


<div class="mb-5">
<p>
◆試合時間について<br>
・各試合時間は7分ハーフで時間流し。<br>
・前後半の各残り30秒からゲームが止まる全てのシチュエーションで時間を止める。<br>
・3秒、5秒、8秒、24秒はレフリーに一任する。<br>
・タイムアウト（以下、T.０と称す）は各1チーム前後半で各1回ずつ、30秒を与える。<br>
・T.Oの申請は出場選手は審判へ、ベンチはオフィシャルへ申請する。申請後、ゲームが止まる全てのシチュエーションで施行されます。<br>
・ケガ等の場合レフリーは自らの判断で時間を止める事が出来る。
</p>
<p>
◆ルールについて<br>
・レフリー、オフィシャル、ゲームマスター（運営部）は自らの判断にて判定する事が出来る。<br>
・パーソナルファウルのカウントはしないが、テクニカルファウルはカウントする。テクニカルファウル2回で退場とする。<br>
・チームファウルはカウントし、前後半でクリアする。各５回目以降にファウルを行うと、シュート動作中のファウルでなくても、1点加点後、相手ボールとなる。<br>
・レフリーへの過度な主張、暴言はテクニカルファウルの対象となる。<br>
・コートの中はもちろん、コート外での過度な主張、<br>
 暴言はテクニカルファウルの対象とし、次回の試合にファウルコールを行う。<br>
・チーム代表者のみが、運営部に主張、申し立てを行う事が出来る。<br>
・ノーチャージエリアの適用はしない。
</p>
<p>
◆得点、大会別ルール<br>
・フリースローが無い大会の場合、フリースローシュチエーション時には、 2スロー以上の場合、１点を加点し、その後、オフェンスボールとなる。１スローの場合は1点を加点後、ディフェンスボールとなる。<br>
・大会により女性プレイヤーへ通常ポイントに加点を行う事がある。<br>
加点内容は事前に大会毎に決定する。（大会加算）<br>
・大会により年齢別にて加点減点を個人または、チームに対し行う事がある。その際、女性の得点は大会加算後に行う。
</p>
<p>
◆大会形式<br>
・総当たりのリーグ戦とする。<br>
   ただし、不参加のチーム等でチーム数に変更がある場合は、上記の事前に告知した内容を変更することがある。<br>
・各試合の勝敗で勝ち数が多いチームの優勝とする。<br>
</p>
<p>
◆その他のルールに関して<br>
・国際バスケットボール連盟(FIBA)が定めた「Official Basketball Rules 2014」に準拠する。
</p>
</div>


    </v-flex>

<div style="text-align: center;">
<div id="sendline-btn" class="line-it-button" data-lang="ja" data-type="share-a" v-bind:data-url="customurl" style="display: none;"></div>
</div>



    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
export default {
  data () {
    return {
      faqs: [
        [
          'チーム統一のユニフォームが無いのですが、参加できますか？',
          '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'
        ],
        [
          '大会の予約はいつからできますか？',
          '大会によって異なるのですが、概ね3か月前から大会当日までとなります。参加チーム枠もありますので、ご連絡ください。'
        ],
        [
          'チーム統一のユニフォームが無いのですが、参加できますか？',
          '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'
        ],
        [
          '当日の持ち物をお教えください。',
          '大会当日は運動できる服装と内履きをご持参ください。当大会ではビブの貸出、ボールの貸出を行っております。ご気軽にご参加ください。'
        ],
        [
          '1チーム何名まで参加できますか？',
          '何名でも可能です。過去に最大で20名で参加されたチームがありました。'
        ],
        [
          '5人以下で参加できますか？',
          'チームにて参加をいただいているのでご遠慮お願いします。ただし、個人参加大会も行っているので、そちらをご検討ください。'
        ],
        [
          '当日、人数が揃わない場合、棄権になってしまいますか？',
          '1名2名の欠員であれば当運営メンバーが代行します。また、大会責任者へご相談いただければ、他チームからの助っ人を募集いたします。'
        ],
        [
          '審判やオフィシャルが出来ないのですが、参加してもいいですか？',
          '審判、オフィシャルは当大会運営部で行います。ご気軽にご参加ください。'
        ],
        [
          'ケガをした時の対応について教えてください。',
          '基本的に怪我は自己責任となります。怪我の責任は一切負いかねます。各自、スポーツ保険に加入されることをお勧めします。'
        ],
        [
          '領収書の発行をお願いできますか？',
          '可能です。当日、お申し出ください。'
        ],
        [
          '同一大会に2チームエントリーしたいのですが、可能でしょうか？',
          '可能です。ただし、皆さんに楽しんでもらうために4チームに同時エントリーはご遠慮いただいております。'
        ],
        [
          'ハーフではなくクオーターで試合はできませんか？',
          '当大会は、多くのチームと試合を行う事で、すべてのチームがエンジョイできる大会を目指しています。クオーター大会も行っていますが、基本はハーフとなります。'
        ],
        [
          '大会の中止はありますか？',
          '当運営部の要因で中止した事はありませんが、交通事情にて予定参加チームが欠席したケースはございます。その場合、予定チーム数の半分以上が欠席の場合、予定とは異なった大会を行わせていただきます。'
        ],
        [
          '学生（20歳以下）が参加できる大会はありますか？',
          '保護者の許可があれば参加可能ですが、代表者様もしくは引率の方は20歳以上とさせてください。'
        ],
        [
          '練習試合を企画しているのですが、協力いただくことは可能でしょうか？',
          'もちろんできる限り協力させていただきますが、ご希望にそぐわない場合もございますので、概要と当大会運営部が行う事をメールにてご連絡ください。'
        ]
      ]
    }
  }
}

</script>

<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Rule.vue